import { buildSlug } from "~/utilities/string"

export const CATEGORIES = {
  parking: "parking",
  traffic: "traffic",
}

export const CATEGORIES_LABELS = {
  [CATEGORIES.parking]: "Parking Tickets",
  [CATEGORIES.traffic]: "Traffic Tickets",
}

export const CATEGORIES_URL = {
  [CATEGORIES.parking]: "parking-tickets",
  [CATEGORIES.traffic]: "traffic-tickets",
}

export const getCategoryFromUrl = (url) => {
  if (typeof url !== "string" || !url.trim().length) return null
  const keys = Object.keys(CATEGORIES_URL)
  return keys.find((key) => CATEGORIES_URL[key] === url.toLowerCase().trim())
}

export const FAQ_CATEGORIES = [CATEGORIES.parking, CATEGORIES.traffic].map(
  (cat) => {
    return {
      color: CATEGORIES.parking === cat ? "red" : "blue",
      category: cat,
      title: CATEGORIES_LABELS[cat],
      slug: CATEGORIES_URL[cat],
    }
  }
)

export const FAQ_ITEMS = [
  {
    question: "What is WinIt?",
    answer: `WinIt is the #1 app to help you easily dispute and manage your parking tickets issued within the 5 boroughs of NYC.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How does WinIt work?",
    answer: `Simply take a picture of your ticket, scan your barcode, or submit your license plate information and WinIt will take it from there.

Once we receive your ticket, our experts will review the violation and schedule a hearing to contest it. We will keep you updated on the status of your ticket via email.

We have partnered with seasoned NYC ticket specialists, who have been disputing thousands of NYC parking tickets for years. Our experts have helped clients save over $250 million in parking ticket fines over the last 20 years.`,
    categories: [CATEGORIES.parking],
  },
  {
    question:
      "I do not have the physical copy of my ticket can I still submit?",
    answer: `It is not required that you have an image of the ticket itself, however, we do suggest you submit the original copy if it is in your possession. If you do not have the physical copy of your NYC parking ticket, you will still be able to submit your ticket within the app, without the image. Be advised that the 10-digit ticket ID number must be correct for our specialists to begin processing your ticket.

You are also able to submit an image of a pre-penalty notice, though please note, you will need to take a clear picture of the document, and the violation number must be visible.

If you are unsure of your tickets 10-digit violation number, please contact our customer support team, and they will assist you with the matter.

Please note that as part of our service, we notify our users whenever they have outstanding parking violations on the NYC Servers. You will be contacted via email whenever a new ticket relative to the plate information you have listed within the app is entered within the system of The NYC Department of Finance. Depending on your user registration, you may receive an SMS regarding the ticket as well.

This service is not a requirement and you will be able to unsubscribe at any time.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How much does WinIt cost?",
    answer: `You won’t be charged unless your ticket is dismissed. Try WinIt risk free!

Submit your ticket for free. We’ll begin to dispute your ticket and you will only be charged if WinIt successfully dismisses your ticket. We charge a service fee equal to 50% of the amount due at the time we receive the court decision.

If your ticket is found guilty, you don’t owe WinIt for the dispute, but keep in mind that you will have to pay NYC Department of Finance. WinIt offers ticket payment processing services, which include a $5.99 service charge and 3% processing fee.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "When should I submit my ticket?",
    answer: `As Soon As Possible

The city may charge you a penalty fee if you don’t pay or dispute your ticket within 30 days of the infraction. To avoid the accrual of penalties, send us your ticket at least 7 business days prior to the 30 days deadline.

Please keep in mind that once we’ve submitted your ticket to court, the penalty cycle is placed on hold by the city until the hearing for your ticket is conducted.

You can always check the status of your ticket using the following link:

Remember, you can always check the status of your ticket by using this link: http://nycserv.nyc.gov/NYCServWeb/NYCSERVMain`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "My ticket was found guilty, how do I pay?",
    answer: `If our experts take the ticket to court but could not dismiss the case, you will be required to pay NYC Department of Finance.

You have two options to pay:

- Go to https://secure24.ipayment.com/NYCPayments/nycbookmark_1.htm. Locate your ticket using your plate or 10-digit violation number and follow the instructions provurled for online payment.
- Click the ‘Pay’ button located to the right of your guilty ticket on your WinIt dashboard. This will prompt the response from our customer support team to process the payment of your ticket using the credit or debit card associated with your WinIt account. Please note there is service charge to have WinIt process your payment.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "When will I be charged?",
    answer: `If your ticket is successfully dismissed, you will be charged WinIt’s standard fee, equal 50% of the ticket amount within 24 hours of the status update.

If you elect to have your tickets’ payment processed, your ticket will be paurl using the payment information associated with your WinIt account within 24 to 48 hours. You will receive a receipt of payment from the NYC department of finance website once the payment is processed.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How do penalties work?",
    answer: `It’s important to note that once a hearing is scheduled for your ticket the penalty cycle is put on hold and you will not incur any additional late fees. If your ticket is found guilty, you will have 30 days from the hearing date to pay the ticket without incurring penalty.

If a ticket is not resolved, the following penalties accrue in addition to the original fine:

- 30 days after the date of the tickets’ issuance, a $10 penalty is assessed
- 45 days after the tickets’ issuance an additional $20 penalty is assessed, bringing the penalty total to $30
- 60 days after the tickets’ issuance, an additional $30 penalty is assessed, bringing the penalty total to $60.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "When should I pay my parking ticket?",
    answer: `Once your ticket is submitted through the app, it is advised that you do not take any further action until you receive an update from our system.

We send automated emails as well as push notifications regarding the status of your ticket.`,
    categories: [CATEGORIES.parking],
  },
  {
    question:
      "I received a letter from NYC Finance Department, what should I do?",
    answer: `Pre-penalty notices sent by The Department of Finance are often automated mail responses. Unfortunately we cannot prevent you from receiving these notices.

As long as your ticket has a hearing scheduled or is paid within 30 days of the tickets’ issuance, you will not need to worry about this notice.

Again we strongly advise that you submit your ticket at least 7 business days before the 30 day limit. This provides our specialists with the time necessary to schedule a hearing for your ticket.

Once the ticket is sent to court, your status will be updated to Hearing Pending.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "What is the estimated timeframe for the process?",
    answer: `The duration of your tickets’ processing will depend on the type of violation you received and the hearing schedule provided by the city.

It typically takes 20 business days from the day you submit your ticket in the app until you receive a final decision from the court.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How can I update my Payment Information?",
    answer: `If you need to update your payment information, you can do so either:

- Within the app, under the ‘My Profile’ section by selecting the ‘Payment Info’ option and entering a valid credit or debit card.
- Email our customer support team at support@appwinit.com and a WinIt representative can assist you in updating your payment information.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "I want to cancel my dispute, how can I do so?",
    answer: `If you submitted a ticket in error, or you would like to cancel the dispute of a ticket, please contact our customer support regarding the matter, and we will assist you in doing so.

It is considerably difficult to close a tickets’ case once the violation has been submitted to court. Please note that depending on how far along our specialists are in the process, your ticket may still be disputed as it would otherwise and can still be dismissed.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "I lost my dispute, is it possible to re-submit my ticket?",
    answer: `If your violation is found guilty, you will NOT be able to re-submit the ticket a second time for an appeal with WinIt. Our specialists will only be able to dispute your ticket once. If your ticket is guilty, we advise that you pay the fine to the city at your earliest convenience, within 30 days of the hearing date.

While it is technically possible to submit your ticket for appeal on your own, we do not advise that you do so. Our specialists have been disputing NYC Parking tickets for over 20 years, if your ticket was not dismissed, it is because the ticket was correctly issued. It is highly unlikely that an appeal will be successful.

In addition, please be aware that as per our terms and conditions, we are unable to provide traditional case details regarding any specific dispute.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How do WinIt referrals work?",
    answer: `- You may start referring friends or family members in need of WinIt’s service by selecting our Referral icon located on your app’s navigation bar, and clicking the “Invite Friends” button on the Friend Referral page.
- You can then select the people whom you wish to refer from your contacts and send them the invite!
- We’ll issue you a $5 credit every time a user you referred submits their first valid ticket.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "What's a Valid Ticket?",
    answer: `A valid ticket is a NYC parking violation issued within the 5 boroughs that has not yet had a hearing and is within it’s 75-day limit, not in judgement.`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How many friends can I refer?",
    answer: `You may refer up to 100 friends. If you’re that popular, that’d be $500 worth of credit, and a bunch of happy friends!`,
    categories: [CATEGORIES.parking],
  },
  {
    question: "How do I use my credit?",
    answer: `- The Winit credit will be applied to your account automatically.
- If a ticket is dismissed, we will automatically deduct the credit from the total charge amount. So if the ticket is $115 and you have a $5 credit, we would only charge you $52.50 instead of our standard service fee of $57.50.
- If a ticket is found guilty, you will have the option within the app to have your ticket’s payment processed via our customer support team. Once this is prompted, your credit will automatically be deducted from your ticket’s total amount.`,
    categories: [CATEGORIES.parking],
  },
  {
    question:
      "How is disputing a traffic ticket different from the dispute of a NYC parking ticket?",
    answer: `In New York City, parking and traffic ticket disputes are entirely separate processes.

In order to provide an official quote for the cost to dispute your violation, the attorneys featured on our site will require a clear photo of your ticket, as well as your driver’s license. Once these materials are submitted, you will be provided with a quote from one of our partnered law firms, detailing the total points at risk for your case, as well as the cost of dispute.

No action will be taken towards disputing your traffic ticket(s) until you confirm your attorney selection in the app and authorize them to do so.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "What are the potential consequences of a NYC Traffic Ticket?",
    answer: `Depending on the type of violation, there are a few different ramifications to consider whenever you’ve received a traffic ticket:

Points: Though not all traffic violations carry points, there are a good share that do, and it is important to note that if your license accumulates over 11 points within an 18 month period, your license may be suspended.

Insurance: If you are convicted of a NYC traffic ticket, it is likely you’ll see a substantial increase on your auto insurance premium.

Additional Fines: In certain situations, you may be liable for what’s known as the Driver’s Responsibility Assessment, which entails an additional fee that is due annually over the course of 3 years.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "How many days do I have to respond to my traffic violation?",
    answer: `Upon the issuance of a NYC traffic ticket, you will have 15 days to respond.

Failure to respond to your traffic violation can ultimately result in the suspension of your driver’s license, and the liability of additional surcharges and fines.

It is advised that you submit your dispute materials to your attorney through the WinIt app as quickly as possible, as doing so will help prevent any such inconvenient consequences.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "My ticket has no points, is it better if I just pay it?",
    answer: `The benefit of dispute for a ticket with no points is the simple advantage of saving yourself a guilty conviction in terms of your driving record. Although no points are associated with the violation, a judge will see this violation when viewing your driving record, and it could be taken into consideration when the fines of future traffic violations are calculated.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question:
      "I already have a Hearing Date, can I still hire a lawyer through WinIt?",
    answer: `Absolutely! If you already have a hearing date scheduled for your traffic ticket, WinIt’s partnered attorneys will still be able to attain representation in your dispute.

In some cases your originally scheduled hearing date will be retained by your attorney, and in some cases the hearing date may be subject to change.

In either scenario we will keep you updated accordingly!`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "Can my hearing date be rescheduled?",
    answer: `Yes! In certain cases, it is in your best interest to have your court hearing rescheduled for a later date. This decision will be made at the discretion of the advocate representing you on the date of the hearing. In the event your court hearing is rescheduled, you will be notified accordingly.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question:
      "It's been over a month since I submitted my ticket, how come I don't have a hearing date?",
    answer: `A NYC traffic ticket must be entered into the New York DMV system by the issuing officer before you or your attorney are able to secure a hearing date for the ticket. Please understand that this process can be considerably slow, and any ticket may take weeks or even months to appear on the DMV website.

It is important to note that during this period of time, you will still remain Not Guilty. We will perform frequent, periodical checks as it pertains to this matter, and you will be promptly notified as soon as your ticket is entered into the system.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question:
      "I got a letter from the DMV about a court date, should I be concerned?",
    answer: `If you receive any notice from the New York State Department of Motor Vehicles during the time your traffic ticket is being disputed, understand that there should be no cause for concern at any point.

DMV correspondence is general and they are typically unaware of who is maintaining representation as it pertains to your dispute.

If you have any questions or concerns, you will be able to communicate directly with your designated attorney.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "I'm required to pay a bond, how does this affect my case?",
    answer: `If your traffic ticket is bonded, you will be required to pay a refundable fee of $40 to the court before you are able to proceed with your dispute. Bonds are typically related to the rescheduling of a court hearing date, but may also be applicable in alternative cases as well.

If your ticket is dismissed, you will receive a full refund for your payment of the bond.

If your ticket is found guilty, the bond will go towards the payment of the ticket fine.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "How can my license be suspended?",
    answer: `Most commonly, your license can be suspended if the total amount of points associated with your Driver’s License supasses 11 within an 18 month period.

In addition, receiving 3 speeding tickets within an 18 month period will ultimately result in a 6 month license revocation.

WinIt does not advise the operation of any vehicle while your license is suspended.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question: "Who will be my Attorney?",
    answer: `You may choose any one of the attorneys available on our platform.

We will provide you with quotes on attorney’s behalf, facilitate the initial communication and process the fees on your behalf but please remember that WinIt is not your lawyer and does not provide legal services. You will enter into a direct agreement with the attorney you appoint to create attorney-client relationship.`,
    categories: [CATEGORIES.traffic],
  },
  {
    question:
      "I'm a traffic attorney, how can I find clients through WinIt's platform?",
    answer: `WinIt is currently expanding our platform to welcome new attorneys and help drivers in more and more areas. View our [contact](/contact) page to schedule a call with one of our reps!`,
    categories: [CATEGORIES.traffic],
  },
].map((item) => {
  item.slug = buildSlug(item.question)
  return item
})

export const getFAQItemsByCategory = (slug) => {
  if (typeof slug !== "string" || !slug.trim().length) return null
  return FAQ_ITEMS.filter((item) => item.categories.includes(slug))
}
